* {
  box-sizing: border-box;
}

:host {
  display: block;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  color: var(--cwc-color-white, #fff);
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  text-align: center;
}

a {
  color: inherit;
  text-decoration: none;
}

.container {
  max-width: 1680px;
  margin-right: auto;
  margin-left: auto;
}

.row {
  display: flex;
  flex-direction: column;
  padding: 54px 20px;
}

.row-1__home-link {
  display: block;
  width: 335px;
  margin: 0 auto;
}

.row-1__home-link img {
  width: 100%;
}

.row-1__home-link p {
  margin-top: 0;
  color: var(--cwc-color-white, #fff);
  font-size: 32px;
  font-family: var(--cwc-font-sans-serif-light);
}

.row-1__social-media {
  display: none;
}

.row-1__contact-wrapper {
  display: block;
  max-width: 335px;
  margin: 2.50rem auto 0;
  background-color: rgba(255,255,255,0.1);
  border: 2px solid rgba(255,255,255,0.2);
  border-radius: 10px;
}

.row-1__phone-icon {
  display: none;
}

.row-1__title {
  text-transform: uppercase;
  font-size: 1rem;
}

.row-1__title span {
  display: block;
  font-size: 32px;
  font-family: var(--cwc-font-sans-serif-light, 'Eina01-Light');
  font-weight: 400;
}

.row-1__linkgroup-title::before {
  display: var(--cwc-footer-linkgroup-title-before, none);
  width: 20px;
  height: 6px;
  background-color: var(--cwc-color-primary, #FFAD00);
  border-radius: 6px;
  content: " ";
  margin: 0 auto -10px;
}

.row-1__linkgroup-title {
  font-size: 24px;
  line-height: 1;
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
  font-weight: 400;

  p {
    margin-top: var(--cwc-footer-linkgroup-title-margin-top, 0);
  }
}

.row-1__linkgroup {
  list-style-type: none;
  padding-left: 0;
  font-size: 16px;
  line-height: 24px;
}

.row-1__linkgroup li {
  margin-bottom: 10px;
}

.row-1__linkgroup a {
  transition: opacity 100ms;
  opacity: 0.6;
}

.row-1__linkgroup a:hover {
  opacity: 1.0;
  text-decoration: underline;
}

.row-2 {
  background-color: var(--cwc-color-secondary-900, #414e57);
}

.row-2__address,
.row-2__address h6 {
  font-size: 1rem;
}

.row-2__address h6 {
  margin: 1rem 0 0;
}

.row-2__address address {
  margin-top: 0.50rem;
  font-style: normal;
  color: var(--cwc-color-secondary-400, #A3AAAD);
}

.row-2__branches {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1.50rem;
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
  font-weight: 400;
}

.row-2__social-media {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin: 4rem auto 0;
  padding: 0;
  list-style-type: none;
  gap: 1.5rem;
}

.row-2__copyright {
  color: var(--cwc-color-white, #fff);
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

.row-2__copyright p:last-child {
  display: flex;
  flex-direction: column;
  line-height: 1.5;
  gap: 1em;
}

.row-2__copyright span.d-none.d-md-inline {
  display: none;
}

.row-3__copyright {
  display: none;
}


@media (min-width:768px) {
  .row-1__home-link-contact {
    display: flex;
    justify-content: space-between;
    gap: 2rem;
  }

  .row-1__home-link {
    text-align: left;
  }

  .row-1__home-link,
  .row-1__contact-wrapper {
    margin: unset;
  }

  .row-1__contact-wrapper {
    width: 300px;
    margin-top: 0;
  }

  .row-1__linkgroups {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    text-align: left;
  }

  .row-1__linkgroup-title::before {
    margin: 0 auto -10px 0;
  }

  .row-2__location {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .row-2__address {
    width: 165px;
    text-align: left;
  }

  .row-2__address h6 {
    margin-top: unset;
  }

  .row-2__branches {
    margin-top: unset;
    text-align: left;
  }

  .row-2__copyright p {
    margin-top: unset;
    margin-bottom: unset;
  }

  .row-2__copyright p:last-child,
  .row-2__copyright span.d-none.d-md-inline {
    display: inline-block;
  }
}

@media (min-width: 1024px) {
  .container {
    padding: 150px 50px 100px;
    display: grid;
    grid-template-columns: auto 165px;
    gap: 4.3%;
  }

  .row {
    padding: 0;
  }

  .row-1__home-link-contact,
  .row-2,
  .row-2__location {
    display: flex;
    flex-direction: column;
  }

  .row-1 {
    display: grid;
    grid-template-columns: clamp(270px, 36.3%, 360px) auto;
    gap: 4.3%;
  }

  .row-1__home-link-contact {
    flex-shrink: 0;
    height: fit-content;
  }

  .row-1__home-link {
    width: 100%;
  }

  .row-1__contact-wrapper {
    width: 100%;
    display: flex;
    padding: 1rem;
    align-items: center;
  }

  .row-1__phone-icon {
    display: inline-block;
    margin-right: 1rem;
  }

  .row-1__title {
    margin: 0;
    text-align: left;
    font-size: clamp(14px, 1.36vw, 17px);
    font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
    font-weight: 400;
  }

  .row-1__title span {
    font-size: clamp(20px, 1.95vw, 28px);
  }

  .row-1__social-media {
    display: flex;
    gap: 1.5rem;
    list-style-type: none;
    padding-left: 0;
  }

  .row-1__linkgroups {
    gap: 4.3%;
  }

  .row-1__linkgroup-title {
    margin-top: 0;
  }

  .row-2 {
    background-color: transparent;
  }

  .row-2__branches {
    margin-top: 2rem;
  }

  .row-2__social-media,
  .row-2__copyright {
    display: none;
  }

  .row-3__copyright {
    display: flex;
    flex-direction: column;
    grid-column: span 2;
    text-align: left;
    font-size: 12px;
  }

  .row-3__copyright p {
    margin-top: 0;
  }
}

@media (min-width: 1366px) {
  .container {
    gap: 6%;
  }

  .row-1 {
    gap: 8%;
  }
}
